module.exports = __webpack_public_path__ + "static/media/qrcode_mini_lu.8a4edf23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/qrcode_mini_lu.svg
// module id = 1731
// module chunks = 0